export const STEP_LABELS = ['Project Basics & Summary', 'Define Objectives', 'Review & Submit'];

interface StepperNumericProps {
  currentStep: number;
}

export function StepperNumeric({ currentStep }: StepperNumericProps) {
  return (
    <div className="space-y-[64px]">
      {STEP_LABELS.map((label, index) => {
        const stepNum = index + 1;

        const status =
          stepNum < currentStep ? 'completed' : stepNum === currentStep ? 'active' : 'pending';

        return (
          <div key={stepNum} className="flex items-start gap-3">
            <div className="relative">
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-[--radi-6] text-lg font-bold ${
                  status === 'completed'
                    ? 'border-[--state-brand-active] bg-[--state-brand-active]'
                    : status === 'active'
                      ? 'border-2xl border-[--state-brand-selected] bg-[--state-brand-active]'
                      : 'border-[--base-border] bg-[--base-fill-1]'
                }`}
              >
                {stepNum}
              </div>

              {/* Connector line */}
              {index < STEP_LABELS.length - 1 && (
                <div
                  className={`absolute left-1/2 top-11 h-[56px] w-[4px] -translate-x-1/2 rounded-full ${
                    stepNum < currentStep ? 'bg-[--state-brand-active]' : 'bg-[--base-fill-2]'
                  }`}
                />
              )}
            </div>

            <span className="pt-2">
              <p className="text-base text-[--text-dark-secondary]">{label}</p>
            </span>
          </div>
        );
      })}
    </div>
  );
}
